// @flow
import React, { Component } from 'react';
import { type Location, type Match, type RouterHistory, withRouter } from 'react-router-dom';
import RegisterForm from 'components/register/RegisterForm';
import { connect } from 'react-redux';
import type { State } from 'store';
import type { AuthResult, SocialAuthResult } from 'store/modules/auth';
import { AuthActions, CartActions, WishActions, UserActions } from 'store/actionCreators';
import storage, { keys } from 'lib/storage';

type Props = {
  managerName: string,
  displayName: string,
  email: string,
  password: string,
  shortBio: string,
  isAllAgree: boolean,
  isAdult: boolean,
  isTerms: boolean,
  isPrivacy: boolean,
  isPromotion: boolean,
  registerToken: string,
  match: Match,
  location: Location,
  history: RouterHistory,
  authResult: AuthResult,
  isSocial: boolean,
  socialAuthResult: SocialAuthResult,
  socialEmail: ?string,
  error: ?{
    name: string,
    payload: any,
  },
  nextUrl: string,
};

let checked1 = false;

// 연락처 유효성 검증 함수
const isValidPhoneNumber = value => {
  const numbers = value.replace(/[^\d]/g, '');
  if (numbers.length < 9) return false;
  if (/^(010|011|016|017|018|019)/.test(numbers)) return numbers.length === 11;
  if (numbers.startsWith('02')) return numbers.length >= 9 && numbers.length <= 10;
  if (/^(03[1-9]|04[1-4]|05[1-5]|06[1-4])/.test(numbers)) return numbers.length >= 10 && numbers.length <= 11;
  return numbers.length >= 9 && numbers.length <= 11;
};

class RegisterFormContainer extends Component<Props> {
  initialize = async () => {
    const { isSocial, history } = this.props;
    const { search } = this.props.location;
  };

  componentDidMount() {
    this.initialize();
  }

  onChange = (e: SyntheticInputEvent<HTMLInputElement>): void => {
    const { value, name } = e.target;
    AuthActions.changeRegisterForm({
      name,
      value,
    });
  };

  onCheckBoxChange = (e: SyntheticInputEvent<HTMLInputElement>): void => {
    const { name, checked } = e.target;
    AuthActions.changeRegisterForm({
      name,
      value: checked,
    });
  };

  onAllAgree = (e: SyntheticInputEvent<HTMLInputElement>): void => {
    const { name, checked } = e.target;
    AuthActions.changeRegisterForm({
      name: 'isAllAgree',
      value: checked,
    });
    AuthActions.changeRegisterForm({
      name: 'isAdult',
      value: checked,
    });
    AuthActions.changeRegisterForm({
      name: 'isTerms',
      value: checked,
    });
    AuthActions.changeRegisterForm({
      name: 'isPrivacy',
      value: checked,
    });
    AuthActions.changeRegisterForm({
      name: 'isPromotion',
      value: checked,
    });
  };

  onAllAgreeBtn = (): void => {
    AuthActions.changeRegisterForm({
      name: 'isAllAgree',
      value: !checked1,
    });
    AuthActions.changeRegisterForm({
      name: 'isAdult',
      value: !checked1,
    });
    AuthActions.changeRegisterForm({
      name: 'isTerms',
      value: !checked1,
    });
    AuthActions.changeRegisterForm({
      name: 'isPrivacy',
      value: !checked1,
    });
    AuthActions.changeRegisterForm({
      name: 'isPromotion',
      value: !checked1,
    });
    checked1 = !checked1;
  };

  onRegister = async () => {
    const {
      email,
      password,
      managerName,
      displayName,
      mobile,
      bizNumber,
      shortBio,
      isAdult,
      isTerms,
      isPrivacy,
      isPromotion,
      history,
      isSocial,
      socialAuthResult,
    } = this.props;

    const form = {
      email,
      password,
      managerName,
      displayName,
      mobile,
      bizNumber,
      shortBio,
      isPromotion,
    };

    if (/.*[A-Z].*/.test(email)) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'email' });
      return;
    }

    if (password.length < 6 || password.length > 30) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'password' });
      return;
    }

    if (managerName.length < 1 || managerName.length > 20) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'managerName' });
      return;
    }

    // if (displayName.length < 1 || displayName.length > 20) {
    //   AuthActions.setError({ name: 'FIELD_RULE', payload: 'displayName' });
    //   return;
    // }

    if (!/^[0-9-]+$/.test(mobile)) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'mobile' });
      return;
    }

    // 연락처 유효성 검증
    if (!isValidPhoneNumber(mobile)) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'mobile' });
      return;
    }

    // if (!/^[0-9]+$/.test(bizNumber)) {
    //   AuthActions.setError({ name: 'FIELD_RULE', payload: 'bizNumber' });
    //   return;
    // }

    // if (shortBio.length > 70) {
    //   AuthActions.setError({ name: 'FIELD_RULE', payload: 'shortBio' });
    //   return;
    // }

    if (!isAdult) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'isAdult' });
      return;
    }

    if (!isTerms) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'isTerms' });
      return;
    }

    if (!isPrivacy) {
      AuthActions.setError({ name: 'FIELD_RULE', payload: 'isPrivacy' });
      return;
    }

    try {
      if (isSocial) {
        if (!socialAuthResult) return;
        const { accessToken, provider } = socialAuthResult;
        await AuthActions.socialRegister({
          accessToken,
          provider,
          form,
        });
      } else {
        await AuthActions.localRegister({
          form,
        });
      }

      const { authResult } = this.props;

      if (!authResult) return;
      const { user } = authResult;

      UserActions.setUser(user);
      await CartActions.getCart();
      await WishActions.getWish();
      storage.set(keys.user, user);
      history.push(this.props.nextUrl || '/');
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { onChange, onRegister, onCheckBoxChange, onAllAgree, onAllAgreeBtn } = this;
    const {
      managerName,
      displayName,
      email,
      password,
      username,
      mobile,
      bizNumber,
      shortBio,
      isAllAgree,
      isAdult,
      isTerms,
      isPrivacy,
      isPromotion,
      socialEmail,
      isSocial,
      error,
    } = this.props;

    return (
      <RegisterForm
        onChange={onChange}
        onRegister={onRegister}
        onCheckBoxChange={onCheckBoxChange}
        onAllAgree={onAllAgree}
        onAllAgreeBtn={onAllAgreeBtn}
        managerName={managerName}
        displayName={displayName}
        email={email}
        password={password}
        username={username}
        mobile={mobile}
        bizNumber={bizNumber}
        shortBio={shortBio}
        isAllAgree={isAllAgree}
        isAdult={isAdult}
        isTerms={isTerms}
        isPrivacy={isPrivacy}
        isPromotion={isPromotion}
        emailEditable={isSocial && !socialEmail}
        error={error}
        hideEmail={isSocial && !email}
      />
    );
  }
}

export default connect(
  ({ auth }: State) => {
    const {
      registerForm,
      registerToken,
      authResult,
      socialAuthResult,
      isSocial,
      verifySocialResult,
      error,
      nextUrl,
    } = auth;
    const {
      email,
      password,
      managerName,
      displayName,
      username,
      mobile,
      bizNumber,
      shortBio,
      isAllAgree,
      isAdult,
      isTerms,
      isPrivacy,
      isPromotion,
    } = registerForm;

    return {
      email,
      password,
      managerName,
      displayName,
      username,
      mobile,
      bizNumber,
      shortBio,
      isAllAgree,
      isAdult,
      isTerms,
      isPrivacy,
      isPromotion,
      registerToken,
      authResult,
      socialAuthResult,
      isSocial,
      socialEmail: verifySocialResult && verifySocialResult.email,
      error,
      nextUrl,
    };
  },
  () => ({}),
)(withRouter(RegisterFormContainer));



// WEBPACK FOOTER //
// ./src/containers/register/RegisterFormContainer.js